import React from 'react';
import { ArrowRight } from 'lucide-react';
import { salaryStudy } from '../data/mock';

const SalaryStudy = () => {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gray-900 rounded-lg p-8 lg:p-12">
          <div className="max-w-2xl">
            <h2 className="text-2xl lg:text-3xl font-serif text-white mb-4">
              {salaryStudy.title}
            </h2>
            <p className="text-gray-300 text-lg mb-8">
              {salaryStudy.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/etude-remuneration"
                className="inline-flex items-center justify-between bg-[#E30022] text-white px-6 py-4 rounded hover:bg-[#c7001d] transition-colors font-medium group"
              >
                <span>{salaryStudy.ctaCandidat}</span>
                <ArrowRight className="h-4 w-4 ml-3 group-hover:translate-x-1 transition-transform" />
              </a>
              <a 
                href="/etude-remuneration"
                className="inline-flex items-center justify-between border-2 border-white text-white px-6 py-4 rounded hover:bg-white hover:text-gray-900 transition-colors font-medium group"
              >
                <span>{salaryStudy.ctaEmployeur}</span>
                <ArrowRight className="h-4 w-4 ml-3 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SalaryStudy;
